import { getAuthCompany } from "../store/app";
import { auth } from "../lib/firebase";
import interceptRefreshToken from "./refreshToken";

function parseJSON(response) {
  if (response.status === 204 || response.status === 205) {
    return null;
  }
  return response.json();
}

function parseError(response) {
  try {
    return response.json();
  } catch (e) {
    return Promise.reject({ message: "Unknown Error" });
  }
}

function baseAdapter(data) {
  return { data };
}

function errorAdapter(err) {
  return { err };
}

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  throw response;
}

function parseBlob(response) {
  return response.blob();
}

function parseResponse(response, responseType) {
  if (responseType === "blob") {
    return parseBlob(response);
  }
  return parseJSON(response);
}

export async function requestOptions(method, body = {}, needsAuth = false) {
  const headers = new Headers();
  const whichMethods = ["POST", "PUT", "PATCH", "DELETE"];
  const extend = whichMethods.indexOf(method) > -1;

  if (extend) {
    headers.append("Accept", "application/json");
    headers.append("Content-Type", "application/json");
  }

  if (needsAuth) {
    const token = await auth.currentUser?.getIdToken();
    const company = getAuthCompany();

    headers.append("Authorization", `Bearer ${token}`);
    headers.append("ControlId", company);
  }

  const options = {
    method,
    headers,
  };

  if (extend) {
    options.mode = "cors";
    options.redirect = "follow";
    options.body = JSON.stringify(body);
  }
  return options;
}

export async function requestOptionsFormData(formData, needsAuth = false) {
  const headers = new Headers();

  if (needsAuth) {
    const token = await auth.currentUser?.getIdToken();
    const company = getAuthCompany();
    headers.append("Authorization", `Bearer ${token}`);
    headers.append("ControlId", company);
  }

  const options = {
    method: "POST",
    headers,
  };

  options.mode = "cors";
  options.redirect = "follow";
  options.body = formData;

  return options;
}

export default function request(url, options, responseType = "json") {
  try {
    return fetch(url, options)
      .then(checkStatus)
      .then((response) => parseResponse(response, responseType))
      .then(baseAdapter)
      .catch((err) =>
        parseError(err)
          .then((_err) => {
            if (_err?.unauthorized) {
              console.log("Unauthorized error, refreshing token...", _err);
              return invalidateSession();
            }
            return errorAdapter(_err);
          })
          .catch((e) => {
            return errorAdapter({
              message: "Unknown Error. Please try again later",
            });
          }),
      );
  } catch (e) {
    return errorAdapter({ message: "Unknown Error. Please try again later" });
  }
}

async function invalidateSession() {
  try {
    await auth.signOut(); // Firebase sign out
  } catch (e) {
    console.warn("Firebase signOut failed", e);
  }
  return { err: "session_invalidated" };
}
